module.exports = __webpack_public_path__ + "static/img/login-background.d3ad58a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/login/login-background.png
// module id = w37t
// module chunks = 62